import React from 'react';
import './NavBarItem.scss';
import { Link, useLocation } from 'react-router-dom';
import { useDataLayerValue } from '../../../DataLayer';



function NavBarItemSearch(props) {
    const [{ lang }] = useDataLayerValue();
    const localtion = useLocation();
    return (
        <div className={`nav-bar-item ${localtion.pathname === '/search' ? 'active-link' : ''}`}>
            <Link to="/search" className="link-subtle" draggable="false" aria-current="page">
                {localtion.pathname === '/search' ?
                    (<div className="icon active-icon">
                        <svg viewBox="0 0 512 512" width="24" height="24" xmlns="http://www.w3.org/2000/svg">
                            <path d="M357.079 341.334l94.476 110.73-32.508 27.683-94.222-110.476q-45.714 30.476-100.826 30.476-36.826 0-70.476-14.349t-57.905-38.603-38.603-57.905-14.349-70.476 14.349-70.476 38.603-57.905 57.905-38.603 70.476-14.349 70.476 14.349 57.905 38.603 38.603 57.905 14.349 70.476q0 23.365-5.841 45.714t-16.635 41.651-25.778 35.555zM224 357.079q28.19 0 53.841-11.048t44.19-29.587 29.587-44.19 11.048-53.841-11.048-53.841-29.587-44.191-44.19-29.587-53.841-11.047-53.841 11.047-44.191 29.588-29.587 44.19-11.047 53.841 11.047 53.841 29.588 44.19 44.19 29.587 53.841 11.048z" fill="currentColor"></path>
                        </svg>
                    </div>) :
                    (<div className="icon ">
                        <svg viewBox="0 0 512 512" width="24" height="24" xmlns="http://www.w3.org/2000/svg">
                            <path d="M349.714 347.937l93.714 109.969-16.254 13.969-93.969-109.969q-48.508 36.825-109.207 36.825-36.826 0-70.476-14.349t-57.905-38.603-38.603-57.905-14.349-70.476 14.349-70.476 38.603-57.905 57.905-38.603 70.476-14.349 70.476 14.349 57.905 38.603 38.603 57.905 14.349 70.476q0 37.841-14.73 71.619t-40.889 58.921zM224 377.397q43.428 0 80.254-21.461t58.286-58.286 21.461-80.254-21.461-80.254-58.286-58.285-80.254-21.46-80.254 21.46-58.285 58.285-21.46 80.254 21.46 80.254 58.285 58.286 80.254 21.461z" fill="currentColor"></path>
                        </svg>
                    </div>)
                }
                <span className="ellipsis-one-line" as="span">{lang === 'en' ? 'Search' : 'Tìm kiếm'}</span>
            </Link>
        </div>
    );
}

export default NavBarItemSearch;